export const CONNECTIVITY_TYPES = [
  { label: "Online", value: true },
  { label: "Offline", value: false }
];

export const FEATURE_TYPES = [
  { label: "None", value: 0 },
  { label: "Menu", value: 1 },
  { label: "Header", value: 2 },
  { label: "Both", value: 3 }
];

export const BRANDING_TYPES = [
  { label: "Rumie", value: "rumie" },
  { label: "Your Organization", value: "org" }
];

export const DEVICE_TYPES = [
  { label: "Rumie Tablet", value: 0 },
  { label: "Android Device", value: 1 },
  { label: "Web App", value: 2 }
];

export const LANGUAGE_ISO_VALUES = [
  { label: "English", value: "eng"},
  { label: "Spanish", value: "spa"},
  // { label: "Arabic", value: "ara"},
  { label: "Persian (Farsi)", value: "fas"},
  { label: "Pushto", value: "pus"},
  { label: "Hindi", value: "hin" },
  { label: "Urdu", value: "urd" },
  { label: "Filipino", value: "fil" },
  { label: "French", value: "fra" },
  { label: "Ukrainian", value: "ukr" },
]
